/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Distillation_Create_From_ChatInputs */



/**
* | output |
* | --- |
* | "Create from chat:" |
*
* @param {Distillation_Create_From_ChatInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const distillation_create_from_chat = /** @type {((inputs?: Distillation_Create_From_ChatInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Distillation_Create_From_ChatInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Aus Chat erstellen:")
	return /** @type {LocalizedString} */ ("Create from chat:")
});